/*
 * @Autor: dc
 * @Date: 2022-02-28 16:35:38
 * @LastEditors: dc
 * @LastEditTime: 2022-03-09 15:15:44
 * @Description: 
 */
/*
 * 模块
 * */
import types from '../types.js'

//定义属性（数据）
var state = {
  user: { id: 0 },
}
//定义getters，用来获取属性
var getters = {
  gameData(state) {
    return state.user;
  },
}
//定义actions，要执行的操作，如流程判断、异步请求等
const actions = {
  gameData({ commit }, data) {
    if (data && (typeof data) === 'object') {
      commit(types.GET_GAMEDATA, data);
    } else if (sessionStorage.getItem('wz_game_data') != null) {
      let data = sessionStorage.getItem('wz_game_data');
      commit(types.GET_GAMEDATA, JSON.parse(data));
    } else {
      console.log('getgameData：no data');
    }

    console.log('getgameData  00 ：', data);
  },
  removeUser({ commit }) {
    commit(types.REMOVE_GAMEDATA);
  },
}
//定义mutations，处理状态（数据）的改变
const mutations = {
  [types.GET_GAMEDATA](state, data) {
    state.user = data;
    sessionStorage.setItem("wz_game_data", JSON.stringify(data));
  },
  [types.REMOVE_GAMEDATA](state) {
    sessionStorage.removeItem('wz_game_data');
    state.user = { id: 0 };
  },
  [types.SET_GAMEDATA](state, data) {
    state.user = data;
  }
}

//导出store对象
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js



// WEBPACK FOOTER //
// ./src/store/modules/gameData.js